<template>
  <div class="flex-fill p-2">
    <transition name="fade">
      <div v-if="!loading.profile">
        <div class="d-flex">
          <div class="m-1">
            <img :src="organization.logo_url" style="max-height: 75px" alt="">
            <div class="text-center" style="font-size: 10px; cursor: pointer" @click="toggled.logoUploader = !toggled.logoUploader">UPLOAD LOGO</div>
          </div>
          <div class="m-1">
            <div class="d-flex align-items-center">
              <div style="font-size: 1.5em; line-height: 1em;">
                {{ organization.name }}
              </div>
              <div class="ml-3">
              <span class="badge badge-maadi m-1" v-for="category in organization.categories" :key="category.value">
                {{ category.text }}
              </span>
              </div>
            </div>
            <div class="d-flex align-items-center" style="font-weight: 300">
              {{ organization.membership_name }}
            </div>
            <div class="d-flex" style="font-weight: 300">
              <span class="mr-2">Manager(s):</span>
              <div class="d-flex badge badge-maadi mr-2 justify-content-center align-items-center" v-for="manager in organization.member_managers" :key="manager.name">
                {{ manager.text  }}
              </div>
            </div>
          </div>
          <div class="ml-auto d-flex align-items-center m-1">
            <div>
              <div style="font-weight: 300; font-size: 0.8em; text-transform: uppercase">
                <a :href="'https://secure.medicalalley.org/admin/accounts/' + organization.account_id" target="_blank">Neon Profile</a>
              </div>
              <div v-if="organization.website_url !== null" style="font-weight: 300; font-size: 0.8em; text-transform: uppercase">
                <a :href="organization.website_url" target="_blank">Website</a>
              </div>
              <div v-if="organization.linkedin_url !== null" style="font-weight: 300; font-size: 0.8em; text-transform: uppercase">
                <a :href="organization.linkedin_url" target="_blank"><i class="fab fa-linkedin"></i>&nbsp;LinkedIn</a>
              </div>
              <div v-if="organization.twitter_screen_name !== null" style="font-weight: 300; font-size: 0.8em; text-transform: uppercase">
                <a :href="'https://twitter.com/' + organization.twitter_screen_name" target="_blank"><i class="fab fa-twitter"></i>&nbsp;Twitter</a>
              </div>
              <div style="font-weight: 300; font-size: 0.8em; text-transform: uppercase">
                <span @click="synchronizeOrganization" style="cursor: pointer">Synchronize</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex flex-wrap align-items-center mt-2">
            <div v-if="!loading.tags">
              <organization-tags v-on:tagsModified="onUpdateTag" v-bind:existing-tags="organization.tags" v-bind:organization-i-d="organization.account_id"></organization-tags>
            </div>
            <div class="d-flex justify-content-center align-items-center" v-if="loading.tags">
              <b-spinner small label="Small Spinner"></b-spinner>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="d-flex flex-column" v-if="toggled.logoUploader" style="font-weight: 300; border: 1px solid #3E597A">
          <!-- logo upload -->
          <div >
            <div class="d-flex flex-column flex-fill p-2 m-1">
              <b-form class="d-flex flex-fill" v-if="!this.loading.imageUpload" @submit="uploadFile">
                <div class="d-flex flex-fill align-items-center">
                  <b-form-file
                    v-model="logoFile"
                    :state="Boolean(logoFile)"
                    placeholder="Upload member logo"
                    drop-placeholder="Drop file here..."
                    class="d-flex flex-fill"
                    size="sm"
                  ></b-form-file>
                </div>
                <div class="d-flex align-items-center ml-2">
                  <b-button size="sm" id="submit" type="submit">Submit</b-button>
                </div>
              </b-form>
            </div>
          </div>
          <div class="d-flex text-center justify-content-center" v-if="message !==null">
            {{ this.message }}
          </div>
        </div>
        </transition>
      </div>
    </transition>
    <div class="flex-fill" v-if="loading.profile">
      <div class="align-self-center text-center">
        <div class="spinner-grow text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../../../api/organizations'
import OrganizationTags from '../OrganizationTags'

export default {
  name: '',
  props: ['organization'],
  components: {OrganizationTags},
  data: function () {
    return {
      memberManagers: {
        toggled: false,
        managers: null
      },
      loading: {
        tags: false,
        managers: false,
        imageUpload: false,
        profile: false
      },
      messages: {
        imageUpload: null
      },
      toggled: {
        logoUploader: false
      },
      profileToggled: false,
      logoToggled: false,
      logoFile: null,
      message: null,
      rankings: null
    }
  },
  methods: {
    onUpdateTag () {
      this.loading.tags = true
      this.reloadTags()
    },
    synchronizeOrganization () {
      this.loading.profile = true
      API.refreshOrganizationData(this.organization.account_id).then(
        response => {
          this.loading.profile = false
        }
      )
    },
    uploadFile (e) {
      e.preventDefault()
      this.loading.imageUpload = true
      let formData = new FormData()
      formData.append('file', this.logoFile)
      API.uploadOrganizationLogo(this.organization.account_id, formData).then(
        result => {
          this.loading.imageUpload = false
          this.logoFile = null
          if (result.data.success) {
            this.message = 'Success!'
          } else {
            this.message = result.message
          }
        }
      )
    },
    reloadTags () {
      this.loading.tags = true
      API.getTagsOfOrganization(this.organization.account_id).then(
        result => {
          this.organization.tags = result.data
          this.loading.tags = false
        }
      )
    }
  }
}
</script>

<style scoped>
  .quick-link{
    background: #eee;
    color: #000;
    padding: 5px;
  }
  .top-link-block {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .link-block {
    border-top: #ccc solid 1px;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organizations/search/SingleOrganizationResult.vue